import {
  GET_CHART_OF_ACCOUNT_ERROR, GET_CHART_OF_ACCOUNT_SUCCESS, GET_CHART_OF_ACCOUNT_REQUEST,
  ADD_CHART_OF_ACCOUNT_REQUEST, ADD_CHART_OF_ACCOUNT_SUCCESS, ADD_CHART_OF_ACCOUNT_ERROR,
  UPDATE_CHART_OF_ACCOUNT_ERROR, UPDATE_CHART_OF_ACCOUNT_SUCCESS, UPDATE_CHART_OF_ACCOUNT_REQUEST,
  DELETE_CHART_OF_ACCOUNT_ERROR, DELETE_CHART_OF_ACCOUNT_REQUEST, DELETE_CHART_OF_ACCOUNT_SUCCESS,
  GET_ALL_CHART_OF_SUB_ACCOUNT_REQUEST,
  GET_ALL_CHART_OF_SUB_ACCOUNT_SUCCESS,
  GET_ALL_CHART_OF_SUB_ACCOUNT_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CHART_OF_ACCOUNT_REQUEST:
      return {
        loading: true,
      };
    case GET_CHART_OF_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_CHART_OF_ACCOUNT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case ADD_CHART_OF_ACCOUNT_REQUEST:
      return {
        loading: true,
      };
    case ADD_CHART_OF_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case ADD_CHART_OF_ACCOUNT_ERROR:
      return {
        ...state,
        loading: false
      };
    case UPDATE_CHART_OF_ACCOUNT_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CHART_OF_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case UPDATE_CHART_OF_ACCOUNT_ERROR:
      return {
        ...state,
        loading: false
      };
    case DELETE_CHART_OF_ACCOUNT_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CHART_OF_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };
    case DELETE_CHART_OF_ACCOUNT_ERROR:
      return {
        ...state,
        loading: false
      };
    // case GET_ALL_CHART_OF_SUB_ACCOUNT_REQUEST:
    //   return {
    //     loading: true,
    //   };
    // case GET_ALL_CHART_OF_SUB_ACCOUNT_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     payload: [payload],
    //   };
    // case GET_ALL_CHART_OF_SUB_ACCOUNT_ERROR:
    //   return {
    //     ...state,
    //     loading: false
    //   };

    default:
      return state;
  }
}
